export default "__VITE_ASSET__o9v5BtT4__"